import React from "react";
import { useLoaderData } from "react-router";

import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import ProfileForm from "./components/ProfileForm";
import { ProfilePageProvider } from "./lib/context";
import { profileFormSchema } from "./lib/ProfileFormSchema";
import "../../../assets/css/umphub/pages/profile.scss";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { getUser } from "../../../lib/api";
import { getUserFromLocalStorage } from "../../../lib/utils";
import { IUser } from "../../../types/api";
import { IUserProfileData } from "../../../types/forms";

export const loader = async ({ params }: any) => {
    let user;

    if (params.userId !== undefined) {
        user = await getUser(params.userId);
    } else {
        const localUser = getUserFromLocalStorage();
        user = localUser && (await getUser(localUser.id));
    }

    return user;
};

const Profile = (): React.JSX.Element => {
    const { user } = useLoaderData() as { user: IUser };
    const dispatch = useAppDispatch();

    const formMethods = useForm<IUserProfileData>({
        mode: "onChange",
        resolver: yupResolver(profileFormSchema),
        defaultValues: {
            id: user.id,
            email: user.email,
            firstName: user.meta.firstName,
            lastName: user.meta.lastName,
            phone: user.meta.phoneNumbers.primary,
            address: user.meta.address,
            address2: user.meta.address2,
            city: user.meta.city,
            state: user.meta.state,
            zipCode: user.meta.zipCode,
            gender: {
                label: user.meta.gender,
                value: user.meta.gender,
            },
            race: {
                label: user.meta.race,
                value: user.meta.race,
            },
            dob: user.meta.dob,
            ssn: user.meta.ssn,
            password: "",
            confirmPassword: "",
        },
    });

    return (
        <ProfilePageProvider
            props={{
                formMethods,
                dispatch,
            }}
        >
            <ProfileForm />
        </ProfilePageProvider>
    );
};

export default Profile;
